import { HttpHeaders, genericObject } from "types/generic";

import fetchWrapper from "./fetch";
import createPromise from "helpers/createPromise";

function getJson<ExpectedResponse extends genericObject>(
  url: string,
  config: RequestInit = {}
): Promise<[ExpectedResponse, HttpHeaders]> {
  return createPromise((resolve, reject) => {
    fetchWrapper(url, {
      ...config,
      headers: { ...(config.headers || {}), Accept: "application/json" },
    }).then(([res, headers]) => {
      res
        .json()
        .then((body) => resolve([body as ExpectedResponse, headers]), reject);
    }, reject);
  });
}

export default getJson;
